import { AddToCart, Product, RemoveFromCart, track } from '@dfds-frontend/tracking'

export interface ProductResult {
  currencyCode: string
  product: Product
}

const getDirection = (isReturnDeparture: boolean): 'Return' | 'Outbound' | 'Oneway' =>
  window.location.search.includes('ONE_WAY') ? 'Oneway' : isReturnDeparture ? 'Return' : 'Outbound'

export const mapToTrackingProduct = (
  code: string,
  routeCode: string,
  departureDate: string,
  departureTime: string,
  offerCode: string,
  price: number,
  quantity: number,
  productCode: string,
  brand: 'SeabookExtra' | 'SeabookDeparture' | 'SeabookMeal' | 'VisitGroupHotel' | 'VisitGroupExtra' | 'SeabookPet',
  returnLeg: boolean
): Product => {
  const departureDateString: string = departureDate?.replace(/-/gm, '')
  const departureTimeString: string = departureTime?.replace(':', '')

  const _offerCode = offerCode || 'UNDEFINED'

  return {
    brand: brand,
    category: `${routeCode}/${departureDateString}/${departureTimeString}/${_offerCode}/${productCode}`, // DKDV/20220629/0800/OFFERCODE OR UNDEFINED/EPREMIUM
    id: code,
    name: code,
    price: price?.toString(),
    quantity: quantity.toString(),
    variant: getDirection(returnLeg),
  }
}

const mapAddToCart = (product: Product, currencyCode: string): AddToCart => {
  return {
    ecommerce: {
      add: {
        products: [product],
      },
      currencyCode: currencyCode,
    },
    event: 'addToCart',
  }
}

const mapRemoveFromCart = (product: Product): RemoveFromCart => {
  return {
    ecommerce: {
      remove: {
        products: [product],
      },
    },
    event: 'removeFromCart',
  }
}

export const trackAddToCartEcommerce = (product: Product, currencyCode: string): void => {
  track<AddToCart>(mapAddToCart(product, currencyCode))
}

export const trackRemoveFromCartEcommerce = (product: Product): void => {
  track<RemoveFromCart>(mapRemoveFromCart(product))
}
